export const RECOMMENDATION_TYPE = {
  BEST_SELLERS: 'bestsellers',
  NEW_ARRIVALS: 'newest-arrivals',
  FREQUENTLY_BOUGHT_TOGETHER: 'frequently-bought-together',
  TRENDING_PRODUCTS: 'trending-products',
  MOST_VIEWED: 'most-viewed',
  RELATED_ITEMS: 'related-items',
}

export const PACKAGES_V4 = {
  BASIC: 'basic',
  ESSENTIAL: 'essential',
  PROFESSIONAL: 'professional',
  FREEMIUM: 'freemium',
}

export const KLAVIYO_RECOMMENDATION_TYPE = [
  {
    title: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemTitle1',
    isBadgeAI: true,
    description: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemDesc1',
    type: RECOMMENDATION_TYPE.FREQUENTLY_BOUGHT_TOGETHER,
    plans: [PACKAGES_V4.ESSENTIAL, PACKAGES_V4.PROFESSIONAL]
  },
  {
    title: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemTitle2',
    isBadgeAI: true,
    description: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemDesc2',
    type: RECOMMENDATION_TYPE.RELATED_ITEMS,
    plans: [PACKAGES_V4.ESSENTIAL, PACKAGES_V4.PROFESSIONAL]
  },
  {
    title: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemTitle3',
    description: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemDesc3',
    type: RECOMMENDATION_TYPE.BEST_SELLERS,
    plans: [PACKAGES_V4.BASIC, PACKAGES_V4.ESSENTIAL, PACKAGES_V4.PROFESSIONAL]
  },
  {
    title: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemTitle4',
    description: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemDesc4',
    type: RECOMMENDATION_TYPE.MOST_VIEWED,
    plans: [PACKAGES_V4.BASIC, PACKAGES_V4.ESSENTIAL, PACKAGES_V4.PROFESSIONAL]
  },
  {
    title: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemTitle5',
    description: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemDesc5',
    type: RECOMMENDATION_TYPE.NEW_ARRIVALS,
    plans: [PACKAGES_V4.BASIC, PACKAGES_V4.ESSENTIAL, PACKAGES_V4.PROFESSIONAL]
  },
  {
    title: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemTitle6',
    description: 'AdminHTML.KlaviyoIntegration.Main.recommendation_ItemDesc6',
    type: RECOMMENDATION_TYPE.TRENDING_PRODUCTS,
    plans: [PACKAGES_V4.BASIC, PACKAGES_V4.ESSENTIAL, PACKAGES_V4.PROFESSIONAL]
  }
]

export const MAP_MODAL_TITLE = {
  [RECOMMENDATION_TYPE.BEST_SELLERS]:
    'AdminHTML.KlaviyoIntegration.PreviewProductsModal.bestSellers',
  [RECOMMENDATION_TYPE.NEW_ARRIVALS]:
    'AdminHTML.KlaviyoIntegration.PreviewProductsModal.newestArrivals',
  [RECOMMENDATION_TYPE.FREQUENTLY_BOUGHT_TOGETHER]:
    'AdminHTML.KlaviyoIntegration.PreviewProductsModal.frequentlyBought',
  [RECOMMENDATION_TYPE.TRENDING_PRODUCTS]:
    'AdminHTML.KlaviyoIntegration.PreviewProductsModal.trending',
  [RECOMMENDATION_TYPE.MOST_VIEWED]: 'AdminHTML.KlaviyoIntegration.PreviewProductsModal.mostViewed',
  [RECOMMENDATION_TYPE.RELATED_ITEMS]:
    'AdminHTML.KlaviyoIntegration.PreviewProductsModal.relatedItems'
};

export const css = `<style type="text/css">
.preview-content {
  padding: 16px 20px;
}

.preview-content .title-type {
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
  padding-bottom: 0;
}

@media only screen and (min-width: 480px) {
  .mj-column-per-50 {
    width: 50% !important;
    max-width: 50%;
  }
}
</style>`;
